'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.355 17.125c.127 0 .23.103.23.231v1.708a.232.232 0 0 1-.23.231h-1.708a.231.231 0 0 1-.231-.231v-1.708a.23.23 0 0 1 .23-.231h1.709Zm-.231.462h-1.246v1.246h1.246v-1.246Zm.277-3.374a.23.23 0 0 1 .23.231v1.708a.23.23 0 0 1-.23.23h-1.707a.23.23 0 0 1-.231-.23v-1.708a.23.23 0 0 1 .23-.231h1.708Zm-2.89-.005a.23.23 0 0 1 .23.231v1.707a.23.23 0 0 1-.23.231H9.804a.23.23 0 0 1-.231-.231v-1.707a.23.23 0 0 1 .23-.231h1.708Zm2.659.467h-1.246v1.246h1.246v-1.246Zm-2.89-.005h-1.245v1.246h1.246V14.67Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.845 9.837a.347.347 0 0 1 .466 0l3.878 3.528a.345.345 0 0 1 .114.256v6.9a.347.347 0 0 1-.347.346H8.201a.347.347 0 0 1-.347-.347v-6.899c0-.097.041-.19.113-.256Zm.233.724-3.53 3.214v6.4h.977v-2.819c0-.128.104-.23.231-.23h1.708a.23.23 0 0 1 .231.23v2.818h3.915v-6.399l-3.532-3.214Zm-.845 7.026H9.987v2.587h1.246v-2.587Zm.616-9.496a.347.347 0 0 1 .458 0l1.528 1.345v-.142h.693v.75l.694.613V8.8h-1.579v-.693h2.47V8.8h-.198v2.465l.573.504-.458.52-3.952-3.477-3.946 3.472-.458-.52Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m21.28 9.793.06.044 2.322 2.113-.466.513-2.09-1.901-3.531 3.213v6.399h.978v-2.818c0-.107.072-.196.17-.223l.06-.008h1.709a.23.23 0 0 1 .222.17l.009.061v2.818h2.706v.693h-6.2a.347.347 0 0 1-.34-.276l-.007-.07v-6.899c0-.073.023-.144.065-.202l.049-.054 3.877-3.529a.348.348 0 0 1 .406-.044ZM3.227 9.788l.06.044 3.878 3.528c.054.05.09.115.105.185l.008.071v6.9a.347.347 0 0 1-.276.34l-.07.006h-6.2v-.693H2.21v-2.588H.733v-.46H2.44a.23.23 0 0 1 .223.168l.008.061v2.82h3.916v-6.4l-3.532-3.214-2.089 1.901-.466-.512 2.322-2.113a.345.345 0 0 1 .406-.044Zm17.033 7.799h-1.246v2.587h1.246v-2.587Zm3.12-.462v.462h-1.476v1.246h1.477v.462h-1.708a.231.231 0 0 1-.231-.231v-1.708c0-.127.104-.231.23-.231h1.709Zm-18.05-.005a.23.23 0 0 1 .23.231v1.708a.231.231 0 0 1-.23.231H3.623a.232.232 0 0 1-.231-.231v-1.708c0-.128.104-.231.23-.231h1.709Zm-.231.462H3.854v1.246H5.1v-1.246Zm18.328-3.37v.463h-1.477v1.245h1.477v.463H21.72a.231.231 0 0 1-.23-.232v-1.707c0-.128.103-.232.23-.232h1.708ZM2.44 14.207c.128 0 .232.104.232.231v1.708a.23.23 0 0 1-.232.231H.733v-.462H2.21V14.67H.731v-.462h1.709Zm18.099.001c.127 0 .23.103.23.231v1.707a.231.231 0 0 1-.23.231H18.83a.23.23 0 0 1-.231-.231v-1.707a.23.23 0 0 1 .23-.231h1.709Zm-15.161 0c.127 0 .23.103.23.231v1.707a.231.231 0 0 1-.23.231H3.67a.23.23 0 0 1-.231-.231v-1.707a.23.23 0 0 1 .23-.231h1.709Zm14.93.462h-1.246v1.246h1.246V14.67Zm-15.161 0H3.9v1.246h1.246V14.67Zm16.188-6.579 2.323 2.044-.458.519-2.087-1.835-3.951 3.695-.473-.506 4.18-3.91a.345.345 0 0 1 .466-.007ZM3.224 8.044l.06.042 1.53 1.346v-.138h.692v.747l.694.612V8.8H4.621v-.692h2.47V8.8h-.198v2.462l.571.503-.457.52-3.953-3.478L.961 10.65l-.458-.52 2.323-2.043a.346.346 0 0 1 .398-.042Z",
    fill: "#87868F"
  })));
});
var FwSet0TownhouseMiddle = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0TownhouseMiddle = FwSet0TownhouseMiddle;